import React from 'react'
import qrIcon from '../../../assets/img/qr.svg'
import { colors } from "@resurs/midas"

const QRCodeLink = ({ description, onClick }) => (
  <div
    onClick={onClick}
    onKeyPress={onClick}
    tabIndex="0"
    role="button"
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    }}
  >
    <img src={qrIcon} alt="QR link" />
    {description && <span
      style={{
        color: colors.primaryMain,
        marginLeft: '10px',
      }}
    >
      {description}
    </span>}
  </div>
)

export default QRCodeLink
